import { render, staticRenderFns } from "./decoration.vue?vue&type=template&id=3443a026&scoped=true"
import script from "./decoration.vue?vue&type=script&lang=js"
export * from "./decoration.vue?vue&type=script&lang=js"
import style0 from "./decoration.vue?vue&type=style&index=0&id=3443a026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3443a026",
  null
  
)

export default component.exports